import { node_observable_component } from 'common/util/ComponentDecorator';
import ObserverUtil from "common/util/ObserverUtil";

@node_observable_component
export default class buy1stepConfirmationForm {
	static classname = 'buy1step-confirmation-form';

	constructor($form) {
		this.$form = $form;

		this.decorateElements();
		this.bindEvents();
	}

	decorateElements() {
		const $input = this.$form.find('.buy1step-confirmation-form-field__input');
		const labelText = $input.eq(0).closest('.buy1step-confirmation-form-field')
								.find('.buy1step-confirmation-form-field__label')
								.html();
		$input.each(function(){
			const $this = $(this);
			const labelText = $this.closest('.buy1step-confirmation-form-field')
				.find('.buy1step-confirmation-form-field__label')
				.html();
			$this.data('required', true);
			$this.data('label', labelText);
			$this.addClass('js-formgroup-decorator');
		});

		if (labelText === 'Email') {
			this.$form.addClass('buy1step-confirmation-form_email-confirm');
		}
	}

	bindEvents = () => {
		ObserverUtil.observe('buy1step-confirmation-form__error', (node) => {
			$(node).closest('.buy1step-confirmation-form-field').find('.formgroup').addClass('formgroup--error');
		});

		$(document).on('input', '.buy1step-confirmation-form-field__input',  function() {
			$(this).closest('.buy1step-confirmation-form-field').find('.buy1step-confirmation-form__error').remove();
		});
	}

}
